import * as menuActions from './actions';
import * as stornoActions from '../storno/actions';
import * as tablesActions from '../tables/actions';
import * as shiftsActions from './report/shifts/actions';
import * as menuCreditDetailAction from '../menu/credit/debtDetail/actions';
import * as menuHabituesAction from '../menu/credit/habitues/actions';
import {fromJS, Record} from 'immutable';

const State = Record({
    menuVisible: false,
    menuType: null,
    popupVisible: false,
    menuTypes: {
        STORNO: 'STORNO',
        CREDITS: 'CREDITS',
        CREDIT_DETAIL: 'CREDIT_DETAIL',
        CHANGE_OFFER: 'CHANGE_OFFER',
        SETTINGS: 'SETTINGS',
        REPORT_MENU: 'REPORT_MENU',
        FAVOURITE: 'FAVOURITE',
        SHIFTS: 'SHIFTS',
        TRANSACTIONS: 'TRANSACTIONS',
        CALCULATE_CASHBOXES: 'CALCULATE_CASHBOXES'
    }
});

const MENU_VISIBLE = 'menuVisible';
const POPUP_VISIBLE = 'popupVisible';
const MENU_TYPE = 'menuType';

const menuReducer = (state = new State(), action) => {

    switch (action.type) {

        case tablesActions.FETCH_LAYOUTS_SUCCESS: {
            const layouts = fromJS(action.payload.data);
            if (layouts.size > 0) {
                return state.set(POPUP_VISIBLE, true);
            }
            return state;
        }

        case tablesActions.SELECT_LAYOUT: {
            return state.set(POPUP_VISIBLE, false);
        }

        case menuActions.SHOW_POPUP_IN_MENU: {
            return state.set(POPUP_VISIBLE, action.payload);
        }

        case menuHabituesAction.BACK_TO_MENU_HABITUES: {
            return state.set(MENU_TYPE, 'CREDITS');
        }

        case menuCreditDetailAction.CHOOSE_HABITUE_DETAIL: {
            return state.set(MENU_TYPE, 'CREDIT_DETAIL');
        }

        case menuActions.CHANGE_MENU_PANEL: {
            const {panel} = action.payload;
            return state.set(MENU_TYPE, panel);
        }

        case menuActions.OPEN_MENU: {
            return state
                .set(MENU_TYPE, null)
                .set(MENU_VISIBLE, true);
        }

        case shiftsActions.DELETE_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.CLOSE_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.PAY_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.FETCH_BAR_REPORT_SHIFTS_ERROR:
        case shiftsActions.FETCH_BAR_REPORT_SHIFT_BARMANS_ERROR:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_BARMAN_ERROR:
        case stornoActions.SELECT_RECEIPT_TO_STORNO:
        case menuActions.CLOSE_MENU: {
            return state.set(MENU_VISIBLE, false);
        }
    }

    return state;
};

export default menuReducer;



// WEBPACK FOOTER //
// ./src/common/menu/reducer.js